export const isAuthenticated = (): boolean => {
  // Check for token in localStorage
  const token = localStorage.getItem("token");
  return !!token; // Return true if token exists, false otherwise
};
